/**
 * Page register
 *
 * @module page-register
 * @version 1.0.0
 * @extends HTMLElement
*/

import getValueFromQueryParams from "../utils/parse-query-params";

customElements.component = 'page-register';

if (!customElements.get(customElements.component)) {

    class pageRegister extends HTMLElement {

        constructor() {

            super();

            window.localStorage.removeItem("last_viewed_showroom");
            const inviteToken = getValueFromQueryParams("inviteToken");
            const inviteToShowroomId = getValueFromQueryParams("inviteToShowroomId");

            if (inviteToken && inviteToShowroomId) {
                window.localStorage.setItem("invite_token", inviteToken);
                window.localStorage.setItem("inviteToShowroomId", inviteToShowroomId);

                this.form = this.querySelector("form");

                this.form.innerHTML += `<input type="hidden" name="return_to" value="/pages/showroom-event?id=${inviteToShowroomId}"/>`
            }

            this.initEvents();
        }

        /**
         * Init events
         *
         * @return {undefined}
         */
         initEvents() {
            this.querySelectorAll("input[type='checkbox'][required]").forEach(input => {

                input.addEventListener('click', () => {
                    if(input.checked) {
                        this.querySelector("[data-submit]").removeAttribute('disabled');
                    } else {
                        this.querySelector("[data-submit]").setAttribute("disabled", "disabled");
                    }
                });

            });
        }

    }

    customElements.define(customElements.component, pageRegister);
}
